// extracted by mini-css-extract-plugin
export var emailBlockLink = "_q3-0";